import createVueComponent from '../createVueComponent';
export default createVueComponent('outline', 'brackets', 'Brackets', [["path",{"d":"M8 4h-3v16h3","key":"svg-0"}],["path",{"d":"M16 4h3v16h-3","key":"svg-1"}]]);